import withAPIAction from '../../../utils/withAPIAction'
import {
  getCheckListAction,
  getCheckListByIdAction,
  deleteCheckListAction,
  createCheckListAction,
  updateCheckListAction,
  getProjectAction,
  getQcTypeListAction,
} from './actions'

import { CreateCheckListReq, UpdateCheckListReq } from './types'

// get list
export const getCheckList = (
  Page: number,
  RowPerPage: number,
  TextFilter: string = ''
) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetConstructRoadCheckList',
    data: {
      UserEmail: state.sensitive.userEmail,
      Page,
      RowPerPage,
      TextFilter,
    },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListAction)
}

// get detail
export const getCheckListById = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetConstructRoadCheckListById',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListByIdAction)
}

export const getQCTypeListForRoad = () => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetQCTypeListForRoad',
    data: { UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getQcTypeListAction)
}

// create check list
export const createCheckList = (data: CreateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'CreateConstructRoadCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(createCheckListAction)
}

// update check list
export const updateCheckList = (data: UpdateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'UpdateConstructRoadCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(updateCheckListAction)
}

// delete check list
export const deleteCheckList = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'DeleteConstructRoadCheckList',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(deleteCheckListAction)
}

export const getProjectSelector = () => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetProjectOnConstructRoadCheckList',
    data: { UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getProjectAction)
}
